<script>
  import { Swiper, SwiperSlide } from 'swiper/svelte';
  import { Navigation, Pagination, A11y } from 'swiper';
  import { createEventDispatcher, onMount } from 'svelte';
  import 'swiper/css';
  import 'swiper/css/navigation';
  import 'swiper/css/pagination';

  export let stepNumber;
  export let maxSteps;
  export let collection;
  export let active;
  export let currentSelection;
  export let selectedHandles;
  let pendingSelection = [];
  let multiSelection = stepNumber == 1 ? false : true;
  const dispatch = createEventDispatcher();

  let section = {};
  
  console.log('collection =>', collection);
  console.log('products => ', collection.products);
  section.title = collection.title.split(' | ').pop();
  section.description = collection.descriptionHtml;

  collection.products.sort((a,b) => (parseFloat(a.variants[0].price) > parseFloat(b.variants[0].price)) ? 1 : ((parseFloat(b.variants[0].price) > parseFloat(a.variants[0].price)) ? -1 : 0));

  function selectProduct(product) {   
    if (multiSelection) {
      if (pendingSelection.indexOf(product.handle) != -1) {
        const handleIndex = pendingSelection.indexOf(product.handle);
        pendingSelection.splice(handleIndex, 1);
        console.log(`[step ${stepNumber}]`, 'removed product =>', product.handle);
      } else {
        pendingSelection.push(product.handle);
        console.log(`[step ${stepNumber}]`, 'pushed product =>', product.handle);
      }
    } else {
      pendingSelection = [];
      pendingSelection.push(product.handle);
      console.log(`[step ${stepNumber}]`, 'pushed product =>', product.handle)
    };

    const selectedProducts = collection.products.filter(product => pendingSelection.includes(product.handle));
    console.log(`[step ${stepNumber}]`, 'pending handles =>', pendingSelection)

    dispatch('selection', {
			products: selectedProducts,
      step: stepNumber
		});
  }

  function viewDetails(title, htmlContent) {
    dispatch('viewDetails', {
			content: htmlContent,
      title: title
		});
  }

  onMount(() => { 
    if (stepNumber === 1) {
      selectProduct(collection.products[0]);
    }
    console.log(`[step ${stepNumber}]`, 'multiselection =>', multiSelection)
  })
</script>

<section class:active={active === true}>
  <header class="section-header">
    <h1 class="section-title title">{section.title}</h1>
    <h2 class="section-subtitle subtitle">Vaihe {stepNumber} / {maxSteps}</h2>
  </header>
  <p class="section-description content">{@html section.description}</p>

  {#if stepNumber === 1}
    <div class="notification is-warning">
      <b>Huom! Paketit sisältävät DJ:n ja/tai tanssijat enintään 5 tunniksi.</b> Lisätunneista laskutamme 55 € / h. Alle 5 tunnin varauksista emme hyvitä käyttämättömiä tunteja.
    </div>
  {/if}

  <!--<pre>{selectedHandles}</pre>-->

  {#if collection && collection.products.length}
    <div class="columns" style="flex-wrap: wrap;">
      {#each collection.products as product}
        <div class="column is-one-half-mobile is-one-third-tablet is-one-quarter-desktop">
          <div class="card {selectedHandles.includes(product.handle) ? 'selected' : ''}">
            <div class="card-image img-slider">
              <Swiper
                modules={[Navigation, Pagination, A11y]}
                slidesPerView={1} navigation>
                {#each product.images as image}
                  <SwiperSlide>
                    <img class="swiper-img" src="{image.src}" alt="{product.title}" loading="lazy"/>
                  </SwiperSlide>
                {/each}
                {#if product.images.length < 1}
                  <div class="swiper-img placeholder">
                    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-image"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                  </div>
                {/if}
              </Swiper>
            </div>  
            <div class="card-content">
              <div class="selection-target content">
                <div class="header mb-5">
                  <h3 class="product-title mb-2">{product.title}</h3>
                  <h5 class="product-price mb-0 has-text-weight-normal">{product.variants[0].price.amount.replace('.00','').replace('.0','')} €
                  {#if stepNumber === 2}
                   / vrk
                  {/if}
                  </h5>
                </div>
                <div on:click={() => selectProduct(product)}>
                  {#if selectedHandles.includes(product.handle) && multiSelection === true}
                    <!-- Muut vaiheet, valitun teksti -->
                    <button class="button is-fullwidth is-medium is-danger is-light">
                      <span class="icon">
                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                        </svg>
                      </span>
                      <span>Poista paketista</span>
                    </button>
                  {:else if selectedHandles.includes(product.handle) && multiSelection === false}
                    <!-- Ensimmäinen vaihe, valitun teksti -->
                    <button class="button is-fullwidth is-medium is-success is-light">
                      <span class="icon">
                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                        </svg>
                      </span>
                      <span>Paketti valittu</span>
                    </button>
                  {:else if multiSelection === true }
                    <!--- Muut vaiheet, ei valittujen teksti -->
                    <button class="button is-fullwidth is-medium is-success">
                      <span class="icon">
                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM14 11a1 1 0 011 1v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 110-2h1v-1a1 1 0 011-1z" />
                        </svg>
                      </span>
                      <span>Lisää pakettiin</span>
                    </button>
                  {:else}
                    <!-- Vaihe 1, ei valittujen teksti -->
                    <button class="button is-fullwidth is-medium is-success">Valitse paketti</button>
                  {/if}
                </div>
                <button on:click={() => viewDetails(product.title, product.descriptionHtml)} class="mt-2 button is-fullwidth is-inverted is-info">
                  <span class="icon">
                    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </span>
                  <span>Lisätiedot ja sisältö</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      {/each}
    </div>
  {/if}
</section>


<style>
  section {
    display: none;
  }
  section.active {
    display: block;
  }

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .section-title {
    padding: 0;
    margin: 0;
  }
  .section-subtitle {
    text-transform: uppercase;
    font-weight: 400;
    font-size: 0.875em;
  }

  .section-description {
    text-align: left;
    max-width: 60rem;
  }

  .selection-target {
    cursor: pointer;
  }  
</style>